/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badges, H6, LI, UL } from '../../AbstractElements';
import { MenuListType, SidebarItemTypes } from '../../Types/Layout.type';
import { RootState } from '../../ReduxToolkit/Store';
import { Href } from '../../Utils/Constants';

export default function SidebarSubMenu({ menu, setActiveMenu, activeMenu, level, className}: MenuListType) {
  const { t } = useTranslation() as any;
  const { pinedMenu } = useSelector((state: RootState) => state.layout);
  const { RoleID } = useSelector((state: RootState) => state.adminAuth);
  const isAdmin = Number(RoleID) === 1 || RoleID == null;

  const location = useLocation();

  const ActiveNavLinkUrl = (path?: string, active?: boolean) => {
    return location.pathname === path ? (active ? active : true) : '';
  };

  const shouldSetActive = ({ item }: SidebarItemTypes) => {
    let returnValue = false;
    if (item?.path === location.pathname) returnValue = true;
    if (!returnValue && item?.children) {
      item?.children.every((subItem) => {
        returnValue = shouldSetActive({ item: subItem });
        return !returnValue;
      });
    }
    return returnValue;
  };

  const handleClick = (item: string) => {
    const temp = [...activeMenu];
    temp[level] = item !== temp[level] ? item : '';
    setActiveMenu([...temp]);
  };

  useEffect(() => {
    menu?.forEach((item: any) => {
      let gotValue = shouldSetActive({ item });
      if (gotValue) {
        let temp = [...activeMenu];
        temp[level] = item.title;
        setActiveMenu(temp);
      }
    });
  }, []);

  // Role-based filtering function
// debugger
  const getFilteredMenu = () => {
    if (isAdmin) return menu; // Admin sees all
    return menu?.filter((item: any) => item.roles?.includes(Number(RoleID)));
  };

  const filteredMenu = getFilteredMenu();

  return (
    <>
      {filteredMenu?.map((item, index) => (
        <LI
          key={index}
          className={`${level === 0 ? 'sidebar-list' : ''} ${pinedMenu.includes(item.title || '') ? 'pined' : ''} 
          ${(item.children
            ? item.children.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true)
            : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title
            ? 'active'
            : ''}`}
          data-title={item.title || ''}
          style={{ position: 'relative' }}
        >

          <Link
            className={`${!className && level !== 2 ? 'sidebar-link ' : item.type === 'sub' ? 'submenu-title' : ''} 
            ${(item.children
              ? item.children.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true)
              : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title
              ? 'active'
              : ''}`}
            to={item.path ? item.path : Href}
            onClick={() => handleClick(item.title || '')}
          >
            {item.icon && <i className={`${item.icon} nav-icon`}></i>}
            <H6>{t(`${item.title}`)}</H6>
            {item.badge ? <Badges color="primary">{item.badgeName}</Badges> : ''}
            {item.children && (activeMenu[level] === item.title ? (
              <i className="iconly-Arrow-Down-2 icli"></i>
            ) : (
              <i className="iconly-Arrow-Right-2 icli"></i>
            ))}
          </Link>
          {item.children && (
            <UL
              className={`simple-list ${level !== 0 ? 'nav-sub-childmenu submenu-content' : 'sidebar-submenu '}`}
              /* Richard, 16 Oct 2026: "I cannot close the MB tab". A menu used to be held
                 open whenever the page you were on sat inside it. Now it opens and closes on
                 the click alone; it still starts open when you land on one of its pages. */
              style={{ display: activeMenu[level] === item.title ? 'block' : 'none' }}
            >
              <SidebarSubMenu
                menu={item.children}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                level={level + 1}
                className="sidebar-submenu"
              />
            </UL>
          )}
        </LI>
      ))}
    </>
  );
}
